// extracted by extract-css-chunks-webpack-plugin
module.exports = {"download-icon":"app-store-call-to-action__download-icon___6tarb","downloadIcon":"app-store-call-to-action__download-icon___6tarb","download-description":"app-store-call-to-action__download-description___ITAcj","downloadDescription":"app-store-call-to-action__download-description___ITAcj"};
    if(module.hot) {
      // 1793839508274
      var cssReload = require("../../../../node_modules/extract-css-chunks-webpack-plugin/dist/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}","cssModules":true});
      module.hot.dispose(cssReload);
      ;
    }
  